import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext.jsx';

const Profile = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="profile-page-container">
      <div className="profile-content">
        {/* Profile Header */}
        <div className="profile-header">
          <div className="profile-avatar-large">
            <div className="avatar-bg-gradient"></div>
            <i className="fas fa-user profile-icon-large"></i>
          
          </div>
          
          <div className="profile-title-section">
            <h1 className="profile-title">User Profile</h1>
            <p className="profile-subtitle">Manage your account information</p>
          </div>
        </div>

        {/* Profile Information Card */}
        <div className="profile-info-card">
          <div className="info-header">
            
            <h3 className="info-title">Account Details</h3>
          </div>

          <div className="profile-details-grid">
            

            <div className="profile-detail-item">
              <div className="detail-label">
                <i className="fas fa-user"></i>
                <span>Full Name</span>
              </div>
              <div className="detail-value">{user?.name || 'Not provided'}</div>
            </div>

            <div className="profile-detail-item">
              <div className="detail-label">
                <i className="fas fa-envelope"></i>
                <span>Email Address</span>
              </div>
              <div className="detail-value">{user?.email || 'Not provided'}</div>
            </div>

            {/* Removed Member Since and User ID as requested */}
          </div>
        </div>

        {/* Action Buttons */}
        <div className="profile-actions">
          <button 
            onClick={() => navigate('/update-password')}
            className="profile-action-btn secondary"
          >
            <i className="fas fa-lock"></i>
            <span>Change Password</span>
          </button>
          
          <button 
            onClick={() => navigate('/dashboard')}
            className="profile-action-btn primary"
          >
            <i className="fas fa-arrow-left"></i>
            <span>Back to Dashboard</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Profile;
